import core from './core';

/**
 * The public methods for the analytics class
 */

export default class AnalyticsInterface extends core {
    constructor(projectId) {
        super(projectId);

        this.impression();
    }

    async view() {
        const country_code = await  this.getCountryCode();

        this.post({
            unique: this.isUnqiue(),
            country_code,
            device: this.getDevice()
        }, 'project-view')
    }

    impression() {
        this.post({}, 'impression');
    }

    interaction(nodeId){
        this.interactions += (this.interactions) ? ',' + nodeId : nodeId;
        this.post({
            view_path: this.interactions
        }, 'node-interactions')
    }

    projectViewDuration(duration){
        const timestamp =  this.mmss(duration);

        this.post({timestamp}, 'project-duration');
    }

    nodeViewDuration(percentage_viewed, node_id){
        this.post({percentage_viewed, node_id}, 'node-duration');
    }

    elementClick(element, node){
        const element_id = (element) ? element.id : false;
        const node_id = (node) ? node.id : false;
        const project_id = (node) ? node.project_id : false;

        if(element_id && node_id && project_id) {
            this.post(
                {element_id, node_id, project_id}
                , 'element-click');
        }

        else {
            console.warn('Unable to post analytics element click');
        }
    }
}

